var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRideRevenue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 34,
    viewBox: "0 0 45 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 19C7 17.5 8 16 10 15L12 9C12.5 7.5 14 6.5 15.5 6.5H24.5C26 6.5 27.5 7.5 28 9L30 15C32 16 33 17.5 33 19V25C33 26 32 27 31 27H30V29C30 30 29 31 28 31H26C25 31 24 30 24 29V27H16V29C16 30 15 31 14 31H12C11 31 10 30 10 29V27H9C8 27 7 26 7 25V19Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 3C28.5817 3 25 6.58172 25 11C25 15.4183 28.5817 19 33 19C37.4183 19 41 15.4183 41 11C41 6.58172 37.4183 3 33 3ZM33.8 6.5V7.4C34.8 7.6 35.6 8.3 35.7 9.3H34.4C34.3 8.7 33.8 8.3 33.1 8.3C32.3 8.3 31.8 8.7 31.8 9.2C31.8 9.7 32.2 10 33.2 10.2C34.5 10.5 35.8 11 35.8 12.3C35.8 13.3 34.9 14.1 33.8 14.3V15.2H32.5V14.3C31.4 14.1 30.5 13.3 30.4 12.1H31.7C31.8 12.9 32.5 13.3 33.2 13.3C34.1 13.3 34.5 12.8 34.5 12.3C34.5 11.7 34 11.4 33 11.2C31.7 10.9 30.5 10.4 30.5 9.2C30.5 8.1 31.4 7.4 32.5 7.2V6.5H33.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRideRevenue);
export default __webpack_public_path__ + "static/media/ic_ride_revenue.8a8ede639220d01a81b10f2e3b32de64.svg";
export { ForwardRef as ReactComponent };